export enum ActiveApp {
  SCOUT,
  MY_DATA,
  SETTINGS,
  RETAIL_MATCHES,
  BOOKMARKS,
  REPORTS,
  SALES_PERFORMANCE,
  NETWORK_AUDIT,
  VISUALIZATIONS,
  GPS_INSIGHTS,
  COMMUNITY_MATCHES,
  PLANNING,
}
